import * as React from 'react';
import { connect } from 'react-redux';
import { withRouteData } from 'react-static';

import ServicesPricingPageComponent from '../../components/ServicesPricingPage/ServicesPricingPage';
import { ServicesPricingPageLocale } from '../../components/ServicesPricingPage/servicesPricingPage.locale';
import { RootState } from '../../RootState';
import { Language } from '../Localization/localizationDuck';

interface ServicesPricingPageProps {
  locale: ServicesPricingPageLocale;
  language: Language;
}

const ServicesPricingPage: React.SFC<ServicesPricingPageProps> = ({ locale, language }) => (
  <ServicesPricingPageComponent locale={locale} language={language} />
);

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default withRouteData(connect(mapStateToProps)(ServicesPricingPage));



// WEBPACK FOOTER //
// /www/client/src/containers/ServicesPricingPage/ServicesPricingPage.tsx